import { render, staticRenderFns } from "./FilterProduct.vue?vue&type=template&id=b83df404&"
import script from "./FilterProduct.vue?vue&type=script&lang=js&"
export * from "./FilterProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports